import { Directive, Input, ElementRef, Renderer2, OnChanges, SimpleChanges, AfterViewInit } from '@angular/core';
import { AbstractControl, FormGroupDirective } from '@angular/forms';

@Directive({
  selector: '[appValidationMessage]',
  standalone: false
})
export class ValidationMessageDirective implements OnChanges, AfterViewInit {
  
  @Input('appValidationMessage') control!: AbstractControl | null;
  @Input() errorMessages: { [key: string]: string } = {}; 

  private errorMessageElement: HTMLElement;

  constructor(
    private el: ElementRef, 
    private renderer: Renderer2,
    private formGroupDirective: FormGroupDirective
  ) {
    this.errorMessageElement = this.renderer.createElement('span');
    this.renderer.setStyle(this.errorMessageElement, 'color', 'red');
    this.renderer.setStyle(this.errorMessageElement, 'font-size', '12px');
    this.renderer.setStyle(this.errorMessageElement, 'display', 'block');

    this.renderer.appendChild(this.el.nativeElement.parentNode, this.errorMessageElement);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['control'] && this.control) {
      this.updateErrorMessage();
      this.control.statusChanges?.subscribe(() => this.updateErrorMessage());
    }
  }

  ngAfterViewInit(): void {
    this.formGroupDirective.ngSubmit.subscribe(() => {
      this.updateErrorMessage();
    });

    this.formGroupDirective.form.valueChanges.subscribe(() => {
      if (this.control && this.control.pristine && this.control.untouched) {
        this.clearErrorMessage();
      }
    });
  }

  private updateErrorMessage(): void {
    if (!this.control) return;

    const shouldShowError = 
      this.control.invalid && 
      (this.control.dirty || this.control.touched || this.formGroupDirective.submitted);

    if (shouldShowError) {
      const errorMessages = this.getErrorMessages(this.control.errors);
      this.errorMessageElement.textContent = errorMessages.join(', ');
    } else {
      this.clearErrorMessage();
    }
  }

  private getErrorMessages(errors: any): string[] {
    if (!errors) return [];
    const messages: string[] = [];

    for (const errorKey of Object.keys(errors)) {
      if (this.errorMessages[errorKey]) {
        messages.push(this.errorMessages[errorKey]); 
      } else {
        if (errorKey === 'required') messages.push('This field is required.');
        if (errorKey === 'minlength') messages.push(`Minimum length is ${errors.minlength.requiredLength}.`);
        if (errorKey === 'email') messages.push('Invalid email format.');
      }
    }

    return messages;
  }

  private clearErrorMessage(): void {
    this.errorMessageElement.textContent = '';  
  }
}
